<!--
    描述：项目管理-- 专家通项目-- 查看详情页
    时间：2022-09-19
    Created by 李家宝
-->
<template>
  <div class="xunjiang-project-msg-main">
    <div class="juyihead">
      <el-tabs v-model="auditType" @tab-click="tabChange(auditType)">
        <el-tab-pane label="项目信息" name="1">
          <!--评标项目-->
          <pro-beseinfo
            v-if="currentData != null && reviewType == '1009007001'"
            :rowData="currentData"
          ></pro-beseinfo>
          <!--评审项目-->
          <reviewProBeseinfo
            v-if="currentData != null && reviewType == '1009007002'"
            :rowData="currentData"
          ></reviewProBeseinfo>
        </el-tab-pane>
        <el-tab-pane
          :label="reviewType == '1009007002' ? '规避信息' : '抽取信息'"
          name="2"
        >
          <expert-needs
            v-if="currentData != null"
            :rowData="rowData"
          ></expert-needs>
        </el-tab-pane>
        <el-tab-pane label="抽取结果" name="3">
          <expert-results
            v-if="extractResuitList != null"
            :businessId="rowData.businessId"
            :rowData="extractResuitList"
            :reviewType="reviewType"
          ></expert-results>
        </el-tab-pane>
        <el-tab-pane label="专家费用发放记录" name="4">
          <expense-release-record
            v-if="extractResuitList != null"
            :rowData="extractResuitList"
          ></expense-release-record>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import expertNeeds from "../component/expert-needs"
import proBeseinfo from "../component/pro-beseinfo"
import reviewProBeseinfo from "../component/review-pro-beseinfo"
import expertResults from "../component/extract-results"
import expenseReleaseRecord from "../component/expense-release-record"
import {
  getExtractResuit,
  selectZJMsgById
} from "../../../../api/modules/projectManagement"
export default {
  components: {
    expertNeeds,
    proBeseinfo,
    reviewProBeseinfo,
    expertResults,
    expenseReleaseRecord
  },
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    audit: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      auditType: "1", //tab项当前值
      currentData: null, // 当前项目的详情数据
      extractResuitList: null,
      reviewType: null // 评标 评审 状态
    }
  },
  created() {
    if (!this.rowData.id) {
      this.$router.push({
        name: "zhuanjia-project-list"
      })
      return
    }
    this.selectZJMsgById()
    this.getExtractResuit()
  },
  methods: {
    // tab切换
    tabChange(val) {
      this.currentPage = 1
      this.pageSize = 10
      if (val == 4) {
        this.auditState = ""
      } else {
        this.auditState = val
      }
    },

    // 获取项目详情
    selectZJMsgById() {
      selectZJMsgById({
        id: this.rowData.id
      }).then((res) => {
        if (res.operationCode == 1) {
          this.currentData = res.data
          this.reviewType = this.currentData.busProjectObj.busType
        }
      })
    },

    // 费用发放记录
    getExtractResuit() {
      getExtractResuit({
        businessId: this.rowData.businessId
      }).then((res) => {
        if (res.operationCode == 1) {
          this.extractResuitList = res.data.data
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.xunjiang-project-msg-main {
  // height: 100%;
  /deep/ .el-tabs__header {
    margin: 0 0 0px;
  }
  .juyihead {
    padding: 15px 15px;
    background: #fff;

    /deep/ .el-tabs__item {
      width: 140px;
    }
  }
}
</style>
